import mediaImg from "../assets/media.png";
import contentImg from "../assets/content.png";
import marketingImg from "../assets/marketing.png";
import bulbImg from "../assets/bulb.png";
import dum from "../assets/dum.png";

export const services = [
  {
    id: "media",
    title: "Media",
    image: mediaImg,
    description:
      "Digital media solutions to help reach your target audience with creative content",
    icon: bulbImg,
    whatOffer: "What We Offer",
    offerImg: dum,
    offerings: [
      "Professional video editing for marketing campaigns",
      "Custom graphics and animation design",
      "High-quality audio production and editing",
      "Social media content optimization",
    ],
  },
  {
    id: "content-writing",
    title: "Content Writing",
    image: contentImg,
    description:
      "Create high-quality content that tells your story and engages your audience",
    icon: bulbImg,
    whatOffer: "What We Offer",
    offerImg: dum,
    offerings: [
      "SEO-optimized blog posts and articles",
      "Website content creation",
      "Technical documentation",
      "Copywriting for marketing materials",
    ],
  },
  {
    id: "marketing",
    title: "Marketing",
    image: marketingImg,
    description:
      "Marketing strategies to grow your business and reach new customers",
    icon: bulbImg,
    whatOffer: "What We Offer",
    offerImg: dum,
    offerings: [
      "Digital marketing campaigns",
      "Social media marketing",
      "Email marketing",
      "Content marketing strategy",
    ],
  },
  {
    id: "digital-media",
    title: "Digital Media",
    image: mediaImg,
    description:
      "Advanced digital solutions for modern business needs and creative outputs",
    icon: bulbImg,
    whatOffer: "What We Offer",
    offerImg: dum,
    offerings: [
      "Digital content creation",
      "Multimedia presentations",
      "Interactive media design",
      "Digital asset management",
    ],
  },
  {
    id: "technical-writing",
    title: "Technical Writing",
    image: contentImg,
    description:
      "Professional documentation and technical content creation services",
    icon: bulbImg,
    whatOffer: "What We Offer",
    offerImg: dum,
    offerings: [
      "API documentation",
      "User manuals and guides",
      "Technical specifications",
      "Process documentation",
    ],
  },
  {
    id: "digital-marketing",
    title: "Digital Marketing",
    image: marketingImg,
    description:
      "Comprehensive digital marketing solutions for online business growth",
    icon: bulbImg,
    whatOffer: "What We Offer",
    offerImg: dum,
    offerings: [
      "SEO optimization",
      "PPC campaign management",
      "Analytics and reporting",
      "Marketing automation",
    ],
  },
];
